export default __webpack_public_path__ + "static/media/seo.84ca6e89.webp";